import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {resetPasswordEmail} from '../../actions/firebase_actions';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
        };
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.translateMessage = this.translateMessage.bind(this);
    }

    translateMessage(message) {
        console.log(message);
        switch (message) {
            case 'The email address is already in use by another account.':
                return 'Email je už zaregistrovaný';
            case 'Password should be at least 6 characters':
                return 'Heslo by malo obsahovať aspoň 6 znakov';
            case 'The email address is badly formatted.':
                return 'Zadaj správny email';
            case 'The password must be 6 characters long or more.':
                return "Heslo musí obsahovať aspoň 6 znakov.";
            case 'There is no user record corresponding to this identifier. The user may have been deleted.':
                return "Daná emailová adresa nie je registrovaná.";
            default:
                return message;
        }
    }

    onFormSubmit(event) {
        event.preventDefault();

        const email = this.refs.email.value;
        this.props.resetPasswordEmail(email).then((data) => {
            if (data.payload.errorCode) {
                this.setState({message: this.translateMessage(data.payload.errorMessage)});
            } else {
                this.setState({message: 'Poslali sme Ti email s linkom na obnovenie hesla!'});
            }
        });
    }

    render() {
        return (

            <div className="col-md-4">
                <form role="form" onSubmit={this.onFormSubmit}>
                    {(this.state.message) && (
                        <div className="alert alert-danger">{this.state.message}</div>
                    )}
                    <div className="form-group">
                        <label htmlFor="txtEmail">Emailová adresa</label>
                        <input
                            type="email" className="form-control" id="txtEmail" ref="email" placeholder="Zadaj email"
                            name="email"
                        />
                    </div>
                    <button type="submit" className="btn btn-default btn-block">Obnoviť heslo</button>
                </form>
            </div>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        resetPasswordEmail,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/app/components/user/reset_password.jsx